import { render, staticRenderFns } from "./AiCamera.vue?vue&type=template&id=04c920e5&scoped=true"
import script from "./AiCamera.vue?vue&type=script&lang=js"
export * from "./AiCamera.vue?vue&type=script&lang=js"
import style0 from "./AiCamera.vue?vue&type=style&index=0&id=04c920e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c920e5",
  null
  
)

export default component.exports